import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { createNamedContext } from "../createNamedContext";
import { useInitalisedConfig } from "./useInitalisedConfig";
import { useConfig } from "../../hooks/config";
export const ConfigContext = createNamedContext("ConfigContext", {});
export function ConfigContextProvider({ value, children, transformQueryParams, }) {
    const config = useInitalisedConfig({
        localConfig: value,
        location: window.location,
        transformQueryParams,
    });
    if (!config)
        return null; // replace with Suspense once that's a thing
    return (_jsxs(ConfigContext.Provider, { value: config, children: [typeof children === "function" ? children(config) : children, _jsx(HTMLLangFromConfig, {})] }));
}
const HTMLLangFromConfig = () => {
    const locale = useConfig("locale", true);
    useEffect(() => {
        const htmlElem = document.querySelector("html");
        if (htmlElem && locale) {
            htmlElem.setAttribute("lang", locale.replace("_", "-"));
        }
    }, [locale]);
    return null;
};
